<template>
  <div class="pass-list-item-content">
    <div class="item" v-for="(item, index) in items" :key="index">
      <div class="label">{{ item.label }}</div>
      <div class="value">{{ item.value }}</div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PassListItemContent',

  /**
   * 属性
   */
  props: {
    item: Object,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    items() {
      const createdAt = new Date(this.item.createdAt).toLocaleDateString(
        navigator.language,
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        },
      );
      return [
        {
          label: '启程',
          value: createdAt,
        },
        {
          label: '全长',
          value: this.item.meta.duration,
        },
        {
          label: '有效期',
          value: '永久',
        },
      ];
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {},
});
</script>

<style scoped>
@import './styles/pass-list-item-content.css';
</style>
